import * as THREE from "three";

export default class RenderingPipeline {
  composer = null;

  fps = 0.0;

  initialize = false;

  renderNeedsUpdate = false;

  controllerManager = null;

  init = () => {
    this.initialize = true;
  };

  render = () => {};

  setRenderNeedsUpdate = (renderNeedsUpdate) => {
    this.renderNeedsUpdate = renderNeedsUpdate;
  };

  getRenderNeedsUpdate = () => {
    return this.renderNeedsUpdate;
  };

  setUpPipeline = (params) => {};

  // To call when renderer is resized
  updateSize = (renderer) => {};

  approxRollingAverage = (average, value, history = 50) => {
    average -= average / history;
    average += value / history;

    return average;
  };

  setScene = (scene) => {};

  sceneUpdated = () => {};

  reset = () => {};
}
